import { useState, useEffect, useRef, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import { transactionApi, ApiMonthlySummary } from "../services/api";

export const useMonthlyData = (selectedMonth: number) => {
  const { user } = useAuth();
  const [summary, setSummary] = useState<ApiMonthlySummary | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const loadingRef = useRef(false);

  const loadMonthlySummary = useCallback(async () => {
    if (!user?.group_id || loadingRef.current) return;

    loadingRef.current = true;
    setLoading(true);
    setError(null);

    try {
      const currentYear = new Date().getFullYear();
      const monthStr = `${currentYear}-${String(selectedMonth + 1).padStart(
        2,
        "0"
      )}`;
      const monthlySummary = await transactionApi.getMonthlySummary(
        user.group_id!,
        monthStr
      );
      setSummary(monthlySummary);
    } catch (err: any) {
      setError(err.message || "Failed to load monthly summary");
      setSummary(null);
    } finally {
      setLoading(false);
      loadingRef.current = false;
    }
  }, [selectedMonth, user?.group_id]);

  useEffect(() => {
    loadMonthlySummary();
  }, [loadMonthlySummary]);

  return { summary, loading, error, refresh: loadMonthlySummary };
};
